import { Flex, UnstyledButton } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'

import { AddGoal } from '@/modules/actionPlan/pages/components/AddGoal/AddGoal'
import { GoalModal } from '@/modules/actionPlan/pages/components/GoalModal/GoalModal'
import { TableFilter } from '@/modules/actionPlan/pages/components/TableFilter/TableFilter'
import type { TableOptionsProps } from '@/modules/actionPlan/pages/components/TableOptions/TableOptions.types'

import { Text } from '@/components/Text/Text'
import { Title } from '@/components/Title/Title'

import CloseIcon from '@/assets/icons/close.svg?react'

import classes from './TableOptions.module.css'

export function TableOptions({
  onFilterChange,
  order,
  readOnly,
}: TableOptionsProps) {
  const [opened, { close, open }] = useDisclosure()

  return (
    <>
      <Flex
        align="center"
        className={classes.container}
        h={66}
        justify="space-between"
      >
        <Title variant="h2_small">Action plan</Title>
        <Flex align="center" gap={{ base: 15, sm: 30 }}>
          <TableFilter onFilterChange={onFilterChange} order={order} />
          {!readOnly && (
            <UnstyledButton onClick={open}>
              <Flex align="center" gap={8}>
                <CloseIcon className={classes.addIcon} />
                <Text variant="body_2_semibold_green">Add goal</Text>
              </Flex>
            </UnstyledButton>
          )}
        </Flex>
      </Flex>

      {!readOnly && (
        <GoalModal onClose={close} opened={opened}>
          <AddGoal onClose={close} />
        </GoalModal>
      )}
    </>
  )
}
